/*
 * @Author: lwk
 * @Date: 2024-03-04 09:52:20
 * @LastEditors: lihaonan lihaonan@eiiplat.com
 * @LastEditTime: 2024-03-28 11:30:53
 * @Description: 请填写简介
 */

import request from "@/utils/request";
import user from "../store/modules/user";

export function getUserInfo() {
  return request({
    url: "/pt/tenant/getMyTenantInfo",
    method: "post"
  })
}
// 获取数据统计table data
export function getuserList(params) {
  return request({
    url: "/system/rq/userList",
    method: "post",
    params
  })
}

// 导出 数据统计
export function expUserList(params) {
    return request({
      url: "/system/rq/expUserList",
      method: "get",
      responseType: 'blob',
      params
    })
  }

  // 获取综合数量统计
export function countNum(params) {
  return request({
    url: "/system/rq/countNum",
    method: "post",
    params
  })
}
  // 查询未按时点评通告
export function notCommentList(params) {
  return request({
    url: "/system/rq/notCommentList",
    method: "post",
    params
  })
}
  // 查询日清发送统计
export function deptList(params) {
  return request({
    url: "/system/rq/deptList",
    method: "post",
    params
  })
}
  // 查询出差列表
export function businessList(params) {
  return request({
    url: "/pt/business-trip/list",
    method: "get",
    params
  })
}
  // 查询列表详情
export function businessConfig(id) {
  return request({
    url: `/pt/business-trip/${id}`,
    method: "get",
  })
}
  // 导出excel
export function exportExcel(params) {
  return request({
    url: `/pt/business-trip/export`,
    method: "get",
    responseType: 'blob',
    params
  })
}

/* 会议纪要相关 */
// 会议纪要列表查询
export function sessionsMinutesList(params) {
  return request({
    url: "/pt/sessions-minutes/list",
    method: "get",
    params
  })
}

// 详情查询
export function sessionsMinutesById(id) {
  return request({
    url: "/pt/sessions-minutes/select-by-id?id="+id,
    method: "get"
  })
}

/* 会议纪要添加 */
export function addSessionsMinutes(params) {
  return request({
    url: "/pt/sessions-minutes/save",
    method: "post",
    data: params
  })
}

// 获取dowbload
export function getDownloadBlob(uid) {
  return request({
    url: "/jz/file/download/pt-eiiplat/"+uid,
    method: "get",
    responseType: 'blob'
  })
}

// 获取用户信息
export function getSystemUserInfo(userId) {
  return request({
    url: "/system/user/get/"+userId,
    method: "get"
  })
}

// 更新会议纪要任务状态 
export function updateSessionsEntry(params) {
  return request({
    url: "/pt/sessions-entry/update",
    method: "put",
    data: params
  })
}

// 会议纪要结果统计 http://localhost:8007/sessions-results/list
export function querySessionsResultList(params) {
  return request({
    url: "/pt/sessions-results/list",
    method: "get",
    params
  })
}

// 会议纪要 结果导出
export function exportSessionResult(params) {
  return request({
    url: "/pt/sessions-results/export",
    method: "get",
    responseType: 'blob',
    params
  })
}

// 获取用户信息
export function getUserList() {
  return request({
    url: "/pt/sessions-minutes/users",
    method: "get"
  })
}

export function deleteSessionEntry(id) {
  return request({
    url: "/pt/sessions-entry/delete/"+id,
    method: "put"
  })
}


// WEBPACK FOOTER //
// ./src/api/dayqing.js